import { initialDataSource } from "@/atoms/common";
import { getSearchParam } from "@/utils";
import { getInitData } from "./utils/getInitData";
const initData = getInitData(false);
interface AppState {
  appBgImageUrl: string;
}
export const appAtom = atom<AppState>({
  appBgImageUrl: "",
});
export const headerAtom = atom({
  WeatherIconImg: initData?.info?.WeatherIconImg ?? "",
  WeatherText: initData?.info?.WeatherText ?? "",
  Temperature: initData?.info?.Temperature ?? {},
  Wind: initData?.info?.Wind ?? {},
  IconId: initData?.info?.IconId ?? "",
});

export const refreshLocAtom = atom<Boolean>(false);
export const toggleCityAtom = atom<Boolean>(false);
export const clickTabAtom = atom<Boolean>(false);
export const positionAtom = atom({
  latitude: 0,
  longitude: 0,
});
export const updatingAtom = atom({
  updating: false,
  showUpdating: false,
});

export const bottomSafeHeightAtom = atom("");
export const currentTimeAtom = atom(new Date().toLocaleString());
export const keyDidAtom = atom<any>(
  getSearchParam("keyDid") || LocalStorage.getItem("KEY_DID") || initData?.info?.keyDid,
);

// 临时测试 把wni标识显示在页面（默认与 commonStateAtom 初始 data.f 一致）
export const dataSourceAtom = atom(initialDataSource);
// 控制底部悬浮广告背景色是否展示
export const isAddBgColorAtom = atom(false);
